import { render, staticRenderFns } from "./PrivilegeTag.vue?vue&type=template&id=046502db&"
import script from "./PrivilegeTag.vue?vue&type=script&lang=js&"
export * from "./PrivilegeTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports